module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAAEx0v4+AAAAAXNSR0IArs4c6QAAALFJREFUOBFj1Cr47/n3P8M2BiBgAhFwoJ7//z+MwwjjoCoBS8OkYGpBNAszI4MXugQWvQwMcJORtD9hQNcK4mNVidVM4rVjMxPJIQgmdnsQ8qSzqG81yMTHQIfI4HMMKGJAnsGrCGQAKFGwgBg3JzIygmhsABZPJHnmCTaTkMVAbkTm42UPK18T5Rm8wYEq+QQUg/CoxheTqPpQebBYBplF9YxAdS+jun0w8qju5REYywB2w1qKDmO2TQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/detailed/detailedIcon.png
// module id = 926
// module chunks = 1